module.exports = __webpack_public_path__ + "img/img3.2252e3f5.svg";